import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"; // New icon for 'More Info'

const CheesecakeTable = ({ data, onEdit, onDelete, onMoreInfo }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {[
              "Internal Name",
              "Display Name",
              "Description",
              "Flavor",
              "Size",
              "Price",
              "Style",
              "Image",
              "Actions",
            ].map((header) => (
              <TableCell
                key={header}
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  backgroundColor: "#f5f5f5",
                }}
                align={header === "Actions" ? "right" : "left"}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((cheesecake) => (
            <TableRow key={cheesecake._id}>
              <TableCell>{cheesecake.name}</TableCell>
              <TableCell>{cheesecake.displayName}</TableCell>
              <TableCell>{cheesecake.description}</TableCell>
              <TableCell>{cheesecake.flavor}</TableCell>
              <TableCell>
                {cheesecake.sizes?.length > 0
                  ? cheesecake.sizes.map((size) => size.name).join(", ")
                  : "N/A"}
              </TableCell>
              <TableCell>
                {cheesecake.sizes?.[0]?.price
                  ? `$${cheesecake.sizes[0].price.toFixed(2)}`
                  : "N/A"}
              </TableCell>
              <TableCell>{cheesecake.style}</TableCell>
              <TableCell>
                <img
                  src={cheesecake.images?.primary}
                  alt={cheesecake.name}
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </TableCell>
              <TableCell align="right">
                <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                  <Tooltip title="Edit" arrow>
                    <IconButton
                      size="small"
                      sx={{
                        color: "#555",
                        border: "1px solid #ddd",
                        ":hover": { backgroundColor: "#f0f0f0" },
                      }}
                      onClick={() => onEdit(cheesecake)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete" arrow>
                    <IconButton
                      size="small"
                      sx={{
                        color: "#555",
                        border: "1px solid #ddd",
                        ":hover": { backgroundColor: "#f0f0f0" },
                      }}
                      onClick={() => onDelete(cheesecake._id)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="More Info" arrow>
                    <IconButton
                      size="small"
                      sx={{
                        color: "#555",
                        border: "1px solid #ddd",
                        ":hover": { backgroundColor: "#f0f0f0" },
                      }}
                      onClick={() => onMoreInfo?.(cheesecake)} // Optional callback if needed
                    >
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CheesecakeTable;
